export function initShare() {

    const viewBtns = document.querySelectorAll(".view-modal");
    const popup = document.querySelector(".popup");
    const overlay = document.querySelector(".popup-overlay");

    if (!popup || !overlay || !viewBtns.length) return;

    const close = popup.querySelector(".popup__header-close");
    const copy = popup.querySelector(".popup__action .btn");

    // share links
    const twitter = popup.querySelector("#twitter");
    const facebook = popup.querySelector("#facebook");
    const mail = popup.querySelector("#mail");

    let shareUrl = window.location.href;
    let shareTitle = "";
    let shareDesc = "";

    function openPopup(){
        popup.classList.add("show");
        overlay.classList.add("show");
        document.body.classList.add("no-scroll");
    }

    function closePopup(){
        popup.classList.remove("show");
        overlay.classList.remove("show");
        document.body.classList.remove("no-scroll");
    }

    function updateShareLinks(){
        const url = encodeURIComponent(shareUrl);
        const title = encodeURIComponent(shareTitle);
        const desc = encodeURIComponent(shareDesc);

        // set href
        if (twitter) {
            twitter.href = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
        }

        if (facebook) {
            facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        }

        if (mail) {
            mail.href = `mailto:?subject=${title}&body=${desc}%0A${url}`;
        }
    }

    // open popup
    viewBtns.forEach(btn => {
        btn.addEventListener("click", (e)=>{
            e.stopPropagation();

            // ambil data dari button
            shareUrl = btn.dataset.url || window.location.href;
            shareTitle = btn.dataset.title || document.title;
            shareDesc = btn.dataset.description || "";

            updateShareLinks();
            openPopup();
        });
    });

    // close button
    close?.addEventListener("click", closePopup);

    // overlay click
    overlay.addEventListener("click", closePopup);

    // esc key
    document.addEventListener("keydown",(e)=>{
        if(e.key === "Escape") closePopup();
    });

    // copy link
    copy?.addEventListener("click", async ()=>{

        try{

            if(navigator.clipboard && window.isSecureContext){
                await navigator.clipboard.writeText(shareUrl);
            }else{
                const textarea = document.createElement("textarea");
                textarea.value = shareUrl;
                textarea.style.position="fixed";
                textarea.style.opacity="0";

                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                textarea.remove();
            }

            const original = copy.innerHTML;
            copy.innerHTML = "Copied";

            setTimeout(()=>{
                copy.innerHTML = original;
            },2000);

        }catch(err){
            console.error("Copy failed",err);
        }

    });

}